import InfoTooltipWithIcon from '@upright/ui/common/generic/components/tooltips/info-tooltip-with-icon';
import styled from 'styled-components';

type Props = {
  text: string;
  tooltipText?: string;
};

export const TextCell = (props: Props) => {
  return (
    <Root>
      <span className="subscription-table-text-cell-text">{props.text}</span>
      {props.tooltipText && (
        <InfoTooltipWithIcon
          position="right"
          style={{ marginLeft: 10, fontSize: 14 }}
          content={<span>{props.tooltipText}</span>}
        />
      )}
    </Root>
  );
};

const Root = styled.td`
  text-align: left;
  display: flex;
  align-items: center;
`;
